export const testSavedViews = [
  {
    title: "All Orders",
    target: "allOrders",
    active:true,
    canRemove: false,
    canEdit: false,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": false
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": true,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
                "dateRangeEndVal": "05/31/2017",
                "dateRangeStartVal": "05/30/2017"
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: true,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: true,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: true,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: true,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: true,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 1",
    target: "savedSearchOne",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: false,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: false,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: false,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: false,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: false,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 2",
    target: "savedSearchTwo",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: false,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: true,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: false,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: true,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: true,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 3",
    target: "savedSearchThree",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: false,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: true,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: false,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: true,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: true,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 4",
    target: "savedSearchFour",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: false,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: true,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: false,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: true,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: true,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 5",
    target: "savedSearchFive",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: false,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: true,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: false,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: true,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: true,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 6",
    target: "savedSearchSix",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: false,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: true,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: false,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: true,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: true,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 7",
    target: "savedSearchSeven",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "ordStatus",
        title: "Actions",
        active:true,
        canToggle:false
      },
      {
        data: "prodName",
        title: "Product Name",
        active: true,
        canToggle: false
      },
      {
        data: "description",
        title: "Description",
        active: false,
        canToggle: true
      },
      {
        data: "facility",
        title: "Facility",
        active: true,
        canToggle: true
      },
      {
        data: "available",
        title: "Available",
        active: false,
        canToggle: true
      },
      {
        data: "ordStatus",
        title: "Order Status",
        active: true,
        canToggle: true
      },
      {
        data: "allocated",
        title: "Allocated",
        active: true,
        canToggle: true
      }
    ]
  }
]

export const testNewSavedView = {
  title: "New Saved Search",
  target: "savedViewUpdatedTarget",
  active:true,
  canRemove: true,
  canEdit: true,
  filters: [
    {
      "filterGroup": "Inventory Status",
      "filterGroupType": "checkbox",
      "filterGroupName": "status",
      "filterGroupInputs": [
        {
          "filterTitle": "In Stock",
          "filterValue": "inStock",
          "filterOperator": "equal",
          "active": true
        },
        {
          "filterTitle": "Low Stock",
          "filterValue": "lowStock",
          "filterOperator": "equal",
          "active": true
        },
        {
          "filterTitle": "Out of Stock",
          "filterValue": "outOfStock",
          "filterOperator": "equal",
          "active": true
        },
      ],
    },
    {
      "filterGroup": "Date Range",
      "filterGroupType": "radio",
      "filterGroupName": "fixedRange",
      "filterGroupInputs": [
        {
          "filterName": "fixedRange",
          "filterTitle": "Today",
          "filterValue": "today",
          "filterOperator": "equal",
          "active": false
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Yesterday",
          "filterValue": "yesterday",
          "filterOperator": "equal",
          "active": false
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Last 7 Days",
          "filterValue": "lastSevenDays",
          "filterOperator": "equal",
          "active": false
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Last 60 Days (Default)",
          "filterValue": "lastSixtyDays",
          "filterOperator": "equal",
          "active": true
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Custom Date Range",
          "filterValue": "customRange",
          "filterOperator": "equal",
          "active": false,
          "childFilters":[
            {
              "filterGroup": "Date Range",
              "filterGroupType": "dateRange",
              "filterGroupName": "dateRange",
              "dateRangeNameStart": "startDate",
              "dateRangeNameEnd": "endDate",
            }
          ]
        },
      ],
    }
  ],
  columns: [
    {
      data: "ordStatus",
      title: "Actions",
      active:true,
      canToggle:false
    },
    {
      data: "prodName",
      title: "Product Name",
      active: true,
      canToggle: false
    },
    {
      data: "description",
      title: "Description",
      active: false,
      canToggle: true
    },
    {
      data: "facility",
      title: "Facility",
      active: false,
      canToggle: true
    },
    {
      data: "available",
      title: "Available",
      active: false,
      canToggle: true
    },
    {
      data: "ordStatus",
      title: "Order Status",
      active: false,
      canToggle: true
    },
    {
      data: "allocated",
      title: "Allocated",
      active: false,
      canToggle: true
    }
  ]
}


// WEBPACK FOOTER //
// ./src/components/lookupTable/stores/savedViews.js